import {InvalidArgumentException} from "../../errors/Exceptions";
import {isString} from "../../utils.js";

/**
 * Class for Turing machine state
 */
export class TmState{
    #name; // is string
    #description; // is string (if present), undefined otherwise

    /**
     *
     * @param name {string} not empty string; can contain only latin characters, digits, underscores.
     * @param description {string} [optional] state description. Non-empty string.
     * Must contain at least one non-whitespace character Must not contain <code>\n</code> character.
     */
    constructor(name, description) {
        // init name
        if(!isString(name)){
            throw new InvalidArgumentException("name must be a String");
        }
        if(name.length === 0){
            throw new InvalidArgumentException("name must be non-empty");
        }
        if(!/^[a-z0-9_]+$/.test(name)){
            throw new InvalidArgumentException("name can contain only latin characters, digits and underscores");
        }
        this.#name = name;

        // init description (if present)
        if(description !== undefined && description !== null){
            if(!isString(description)){
                throw new InvalidArgumentException("description (if present) must be a string");
            }
            if(description.length <= 0){
                throw new InvalidArgumentException("description (if present) must be non-empty string");
            }
            if(description.includes("\n")){
                throw new InvalidArgumentException("description (if present) must not contain \\n character");
            }
            if(!/^(?!\s*$).+/.test(description)){
                throw new InvalidArgumentException("description (if present) must contain at least one non-whitespace character");
            }
            this.#description = description.trim();
        }

    }

    /**
     *
     * @return {string}
     */
    get name(){
        return this.#name;
    }

    /**
     *
     * @return {string}
     */
    get description(){
        return this.#description;
    }

    /**
     * Compares two <code>TmState</code> objects (by <code>name</code> property).
     * Be careful, <code>description</code> property is not considered.
     * @param other {any} any object
     * @return {boolean}
     */
    equals(other){
        if(!(other instanceof TmState)){
            return false;
        }

        if(this === other){
            return true;
        }
        return this.name === other.name;
    }

    /**
     *
     * @return {string}
     */
    toString(){
        if(!this.#description){
            return this.#name;
        }
        return `${this.#name} (${this.#description})`;
    }

    /**
     * Gives string representation of <code>State</code>, including only <code>name</code>.
     *
     * Equal States (in terms of <code>equals()</code> method) always give same results of this method.
     * @return {string}
     */
    toShortString(){
        return `${this.#name}`;
    }

}

/**
 * Finds the first occurrence of state with given <code>name</code>
 * @param states {TmState[]} array of states
 * @param name {string}
 */
export const findStateByName = (states, name) => {
    return states.find(s => s.name === name);
}